/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// Rules are disabled because a div that has an onclick here is used only
// for events propagation and decorative purposes

import React from 'react';
import PropTypes from 'prop-types';


const AraraIcon = ({
  name, variant, className, onClick, noVariants,
}) => {
  const iconName = noVariants ? `/icons2/${name}@1x.png` : `/icons2/${name}-${variant}@1x.png`;
  const path = process.env.PUBLIC_URL + iconName;

  return (
    <img
      src={path}
      className={className}
      onClick={onClick}
      alt=""
    />
  );
};

AraraIcon.defaultProps = {
  variant: 'gray',
  onClick: () => {},
  className: null,
  noVariants: false,
};

AraraIcon.propTypes = {
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  noVariants: PropTypes.bool,
};

export default AraraIcon;
